import { useEffect, type ReactNode } from 'react'
import { useUiStore } from '@/stores/uiStore'

interface ThemeProviderProps {
  children: ReactNode
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  const mode = useUiStore((state) => state.mode)

  useEffect(() => {
    const root = document.documentElement
    root.classList.toggle('dark', mode === 'dark')
    root.dataset.theme = mode
  }, [mode])

  return <>{children}</>
}
